
import React, {useEffect, useState} from "react";

function getCookie(name) {
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(name + "=") === 0) {
            return cookie.substring(name.length + 1);
        }
    }
    return "";
}

function setCookie(name, value, minutes) {
    let date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    let expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

const COOKIE_ACCEPTED_COOKIE_NAME = 'cookies-accepted';
const COOKIE_ACCEPTED_COOKIE_TTL_MINUTES = 60 * 24 * 365;

export default function Widgets() {
    // Cookies start
    const [cookieAccepted, setCookiesAccepted] = useState(true);

    useEffect(() => {
        const isAccepted = !!getCookie(COOKIE_ACCEPTED_COOKIE_NAME);
        setCookiesAccepted(isAccepted);
    }, []);

    const acceptCookies = () => {
        setCookie(COOKIE_ACCEPTED_COOKIE_NAME, '1', COOKIE_ACCEPTED_COOKIE_TTL_MINUTES);
        setCookiesAccepted(true);
    }

    return (
        <div className="fixed bottom-0 w-full px-4 mb-4 lg:right-6 lg:left-auto lg:w-max lg:max-w-2xl z-50">
            {!cookieAccepted && (
                <div className="widgets-item bg-yellow-400 cookies-accepted-widget w-full p-4 rounded-lg shadow flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-gray-800 text-center sm:text-left">
                        Мы используем файлы cookies, чтобы сайт работал лучше. Продолжая пользоваться сайтом, вы соглашаетесь
                        с <a className="text-red-500" href="/terms_of_service">пользовательским соглашением</a> и <a className="text-red-500" href="/privacy_policy">политикой конфиденциальности</a>.
                    </p>

                    <button
                        type="button"
                        className="mt-4 sm:mt-0 sm:ml-6 px-6 py-3 text-white bg-red rounded font-lg font-bold hover:bg-red-light active:bg-red-saturated hover:shadow-red-light"
                        onClick={() => acceptCookies()}
                    >
                        Хорошо
                    </button>
                </div>
            )}
        </div>
    )
}